import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'productUnit',
    serviceName: 'graphql',
    query: gql`
      query productUnit($ids: [String]) {
        productUnit(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
